import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { SharedService } from "../../../shared/services/shared.service";
import { TokenService } from "../../tokenManagement/token.service";

@Injectable()
export class SettlementGuard implements CanActivate {
  perms = this.shared.permissions;
  constructor(
    private shared: SharedService,
    private router: Router,
    private token: TokenService
  ) {
    this.shared.activatePermmisions();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let isPermitted: boolean = false;
    if (this.perms.GET_CLIENT_SETTLEMENTS) {
      isPermitted = true;
    } else {
      // this.token.clearStorage();
      this.router.navigate(["/auth"]);
      // location.reload();
      return isPermitted;
    }
    return isPermitted;
  }
}
